

import { Component, Vue } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
  }
})
export default class App extends Vue {
  data () {
    return {
    }
  }

  /* mounted () {
  } */
}
